module.exports = __webpack_public_path__ + "static/img/scratch-handle-bg.1826b2f7.png";